import React, { useEffect, useState, useCallback } from 'react';
import { adminApi } from '../../services/api';
import toast from 'react-hot-toast';
import { Check, X as XIcon, Download } from 'lucide-react';

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export default function AdminVacations() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('pending');
  const [exporting, setExporting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = statusFilter ? { status: statusFilter } : {};
      const res = await adminApi.getVacationRequests(params);
      setRequests(res.data.results || res.data);
    } catch { toast.error('Error al cargar.'); }
    setLoading(false);
  }, [statusFilter]);

  useEffect(() => { load(); }, [load]);

  const updateStatus = async (id, status) => {
    try {
      await adminApi.updateVacationRequest(id, { status });
      toast.success(status === 'approved' ? 'Aprobada' : 'Rechazada');
      load();
    } catch { toast.error('Error al actualizar.'); }
  };

  const handleExport = async () => {
    setExporting(true);
    try {
      const params = statusFilter ? { status: statusFilter } : {};
      const res = await adminApi.exportVacations(params);
      downloadBlob(new Blob([res.data]), 'vacaciones_saeweb.xlsx');
      toast.success('Excel descargado.');
    } catch { toast.error('Error al exportar.'); }
    setExporting(false);
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <h1>Solicitudes de Vacaciones</h1>
        <button className="btn btn--secondary" onClick={handleExport} disabled={exporting}>
          <Download size={16} />
          {exporting ? 'Exportando...' : 'Exportar Excel'}
        </button>
      </div>

      <div className="filter-bar">
        <select className="form-input" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
          <option value="">Todas</option>
          <option value="pending">Pendientes</option>
          <option value="approved">Aprobadas</option>
          <option value="rejected">Rechazadas</option>
        </select>
      </div>

      {loading ? <div className="spinner" /> : (
        <div className="card">
          {requests.length === 0 ? (
            <div className="empty-state"><p>No hay solicitudes</p></div>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Empleado</th>
                  <th>Código</th>
                  <th>Restaurante</th>
                  <th>Semanas solicitadas</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {requests.map(r => (
                  <tr key={r.id}>
                    <td>{new Date(r.created_at).toLocaleDateString('es-ES')}</td>
                    <td>{r.employee_name}</td>
                    <td>{r.employee_code || '—'}</td>
                    <td>{r.restaurant_name || '—'}</td>
                    <td style={{ maxWidth: 250, whiteSpace: 'pre-wrap', fontSize: '0.84rem' }}>{r.preferred_weeks}</td>
                    <td>
                      <span className={`badge badge--${r.status === 'approved' ? 'success' : r.status === 'rejected' ? 'danger' : 'warning'}`}>
                        {r.status === 'pending' ? 'Pendiente' : r.status === 'approved' ? 'Aprobada' : 'Rechazada'}
                      </span>
                    </td>
                    <td>
                      {r.status === 'pending' && (
                        <div style={{ display: 'flex', gap: 4 }}>
                          <button className="btn btn--sm" style={{ background: 'var(--success)', color: 'white' }} onClick={() => updateStatus(r.id, 'approved')}>
                            <Check size={14} />
                          </button>
                          <button className="btn btn--sm btn--danger" onClick={() => updateStatus(r.id, 'rejected')}>
                            <XIcon size={14} />
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
